export var VaultStorageTier;
(function (VaultStorageTier) {
    VaultStorageTier["VAULT_STORAGE_TIER_STANDARD"] = "STANDARD";
    VaultStorageTier["VAULT_STORAGE_TIER_COLD"] = "COLD";
})(VaultStorageTier || (VaultStorageTier = {}));
